import React from "react";
import { TbFileText, TbPencil } from "react-icons/tb";
import {
  Box,
  Col,
  Dialog,
  FabButton,
  Gap,
  Icon,
  InputField,
  Row,
  Typography,
} from "../../../ppui";
import { Card, CardHeading, OrganizationBx, OrganizationEmDetails } from "../../style";
const StatutoryComplianceView = ({handleChange,
  complianceData,
  complianceViewData,
  handleOpenStatutoryComplianceModal,
  handleCloseStatutoryComplianceModal,
  setOpenComplianceModal,
  handleSubmit,
  loading,}) => {

  return (
    <>
      <Card>
      <CardHeading  Divider>
      Compliance Information
      <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryComplianceModal}
          variant="filled"
          shape="box"
        />
      </CardHeading>
          <Gap height={10} />

      <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileText /> {/* Suitable for NIC Code */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                NIC Code
              </Typography>
              <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                {complianceViewData?.nic_code || '-'}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileText /> {/* Suitable for LIC Code (assuming it's text-based) */}
              {/*  alternatively use <TbLicense/> */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
              LIC Code  {/*  "LIC Code"  */}
              </Typography>
              <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                {complianceViewData?.lic_code || '-'}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>
      </Card>
     
      {/*Modal */}
      <Dialog
        title="Compliance Information"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={setOpenComplianceModal}
        onClose={handleCloseStatutoryComplianceModal}
        onSubmit={handleSubmit}
        separator
        buttonLoading={loading}
      >
        <Row rowGap>
         

                 <Col sm={6}>

                    <InputField
                        fullWidth
                        name="nic_code"
                        label="NIC Code"
                        placeholder="Type Here..."
                        type="tel"
                        value={complianceData?.nic_code}
                        valueSinc={!!complianceData?.nic_code}
                        onChange={(e)=>handleChange(e.target.value,"nic_code")}
                    />
                </Col>

                       <Col sm={6}>

                    <InputField
                        fullWidth
                        name="lic_code"
                        label="LIC Code "
                        placeholder="Type Here..."
                        type="tel"
                        value={complianceData?.lic_code}
                        valueSinc={!!complianceData?.lic_code}
                        onChange={(e)=>handleChange(e.target.value,"lic_code")}
                    />
                </Col>
        </Row>
      </Dialog>
      {/*Modal */}
    </>
  );
};

export default StatutoryComplianceView;
